import { createActionGroup, props } from '@ngrx/store';
import { MethodsForScopeDto } from './method.model';

export const MethodActions = createActionGroup({
  source: 'Method API',
  events: {
    'Get Methods For Scope Success': props<{
      methodsForScopeDto: MethodsForScopeDto;
    }>(),
    'Get Methods For Scope Failure': props<{ error: Error }>(),
  },
});
